/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TriageResult = {
    Pending: 'pending',
    Keep: 'keep',
    Discard: 'discard',
} as const;
export type TriageResult = typeof TriageResult[keyof typeof TriageResult];


export function instanceOfTriageResult(value: any): boolean {
    for (const key in TriageResult) {
        if (Object.prototype.hasOwnProperty.call(TriageResult, key)) {
            if (TriageResult[key as keyof typeof TriageResult] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TriageResultFromJSON(json: any): TriageResult {
    return TriageResultFromJSONTyped(json, false);
}

export function TriageResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): TriageResult {
    return json as TriageResult;
}

export function TriageResultToJSON(value?: TriageResult | null): any {
    return value as any;
}

export function TriageResultToJSONTyped(value: any, ignoreDiscriminator: boolean): TriageResult {
    return value as TriageResult;
}

